import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogRoutingModule } from './catalog-routing.module';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { NbMenuModule } from '@nebular/theme';
import { CatalogComponent } from './catalog.component';



@NgModule({
  declarations: [CatalogComponent],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    UbsViewContainersModule,
    NbMenuModule
  ],
  exports:[
    CatalogRoutingModule
  ]
})
export class CatalogModule { }
